import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";
import { useLanguage } from "../LanguageContext";
import { axiosInstance } from "../helper/axiosInstance";
import { whistleblowingText } from "../pages/whistleblowingText";

function Footer() {
    const { language, textContent, footerText } = useLanguage();
    const location = useLocation();
    const [pageUpdated, setPageUpdated] = useState(null);

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    useEffect(() => {
        // Map route to page name in database
        const routeToPageMap = {
            "/": "home",
            "/about": "about",
            "/services": "services",
            "/reports": "reports",
            "/careers": "careers",
            "/contacts": "contacts",
            "/documents": "documents",
            "/tenders": "tenders",
            "/banks": "banks",
            "/structure": "structure"
        };

        const pageName = routeToPageMap[location.pathname];

        if (pageName) {
            axiosInstance.get(`/page-updated/lang?page=${pageName}`)
                .then(response => {
                    setPageUpdated(response.data.updated_at);
                })
                .catch(error => {
                    console.error("Error fetching page updated date:", error);
                });
        }
    }, [location.pathname]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    return (
        <>
            {pageUpdated && (
                <div className="page-updated" style={dynamicStyles}>
                    {textContent[language].pageUpdatedText} {formatDate(pageUpdated)}
                </div>
            )}
            <div className={`footer ${language === "ARM" ? "arm-language" : ""}`}>
                <div className="footer-description">
                <span>Arca</span>
                <p style={dynamicStyles}>{footerText[language][0].description}</p>
            </div>
            <div className="footer-container">
                <div className="footer-links">
                    <div className="footer-link">
                        <span style={dynamicStyles}>{textContent[language].links}</span>
                        <div className="footer-link_items">
                            <Link to="/about" style={dynamicStyles}>
                                {" "}
                                {textContent[language].about}
                            </Link>
                            <Link to="/services" style={dynamicStyles}>
                                {" "}
                                {textContent[language].services}
                            </Link>
                            <Link to="/news" style={dynamicStyles}>
                                {" "}
                                {textContent[language].news}
                            </Link>
                            <Link to="/reports" style={dynamicStyles}>
                                {" "}
                                {textContent[language].reports}
                            </Link>
                            <Link to="/careers" style={dynamicStyles}>
                                {" "}
                                {textContent[language].careers}
                            </Link>
                            <Link to="/contacts" style={dynamicStyles}>
                                {" "}
                                {textContent[language].contacts}
                            </Link>
                            <Link to="/documents" style={dynamicStyles}>
                                {" "}
                                {textContent[language].documents}
                            </Link>
                            <Link to="/tenders" style={dynamicStyles}>
                                {" "}
                                {textContent[language].tenders}
                            </Link>
                            <Link className="whitespace" to="/banks" style={dynamicStyles}>
                                {" "}
                                {/* {textContent[language].materials} */}
                                {textContent[language].banks}
                            </Link>
                            <a href={`/arcapay/?${language === "ARM" ? "arm" : "eng"}`} target="_blank" rel="noopener noreferrer" style={dynamicStyles}>
                                {" "}
                                {textContent[language].arcapay}{" "}
                            </a>
                            <Link to="/useful-links" style={dynamicStyles}>
                                {" "}
                                {textContent[language].usefulLinks}
                            </Link>
                            {/* Label comes from whistleblowingText, not the translate blob, so the
                                link cannot end up pointing at a page with no way to name it. */}
                            <Link to="/whistleblowing" style={dynamicStyles}>
                                {" "}
                                {(whistleblowingText[language] || whistleblowingText.ENG).header}
                            </Link>
                        </div>
                    </div>
                    <div className="footer-link footer-link-mobile">
                        <span style={dynamicStyles}>{footerText[language][3].social}</span>
                        <div className="footer-link_items">
                            <a href="https://www.facebook.com/armeniancard" target="_blank" rel="noreferrer">
                                Facebook
                            </a>
                            <a href="https://www.linkedin.com/company/1460902" target="_blank" rel="noreferrer">
                                LinkedIn
                            </a>
                            <a href="https://www.instagram.com/arca.armenia" target="_blank" rel="noreferrer">
                                Instagram
                            </a>
                            <a href="https://www.youtube.com/@Arca-ArmenianCardCJSC" target="_blank" rel="noreferrer">
                                YouTube
                            </a>
                        </div>
                    </div>
                    <div className="footer-link">
                        <span style={dynamicStyles}>{footerText[language][1].address}</span>
                        <div className="footer-link_items">
                            <a style={dynamicStyles} href="https://maps.app.goo.gl/G8cARCiXGU4qcLNy8" target="_blank" rel="noreferrer">
                                {footerText[language][1].address1}
                            </a>
                            <a style={dynamicStyles} href="https://maps.app.goo.gl/kN5bG1M8gVUXzygXA" target="_blank" rel="noreferrer">
                                {footerText[language][1].address2}
                            </a>
                            {footerText[language][1].address3 && (
                                <a style={dynamicStyles} href={footerText[language][1].mapUrl3 || undefined} target="_blank" rel="noreferrer">
                                    {footerText[language][1].address3}
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="footer-link">
                        <span style={dynamicStyles}>{footerText[language][2].contact}</span>
                        <div className="footer-link_items">
                            <a href="tel:+37410592222" style={dynamicStyles}>
                                {footerText[language][2].phoneNumber}
                            </a>
                            {/* <a href="tel:+37410440390">+374 10 44 03 90</a> */}
                            <a href="mailto:info@arca.am" style={dynamicStyles}>
                                {footerText[language][2].mail}
                            </a>
                        </div>
                    </div>
                    <div className="footer-link footer-link-desktop">
                        <span style={dynamicStyles}>{footerText[language][3].social}</span>
                        <div className="footer-link_items">
                            <a href="https://www.facebook.com/armeniancard" target="_blank" rel="noreferrer">
                                Facebook
                            </a>
                            <a href="https://www.linkedin.com/company/1460902" target="_blank" rel="noreferrer">
                                LinkedIn
                            </a>
                            {/* <a href="https://wa.me/yourwhatsapplink" target="_blank" rel="noreferrer">
                                WhatsApp
                            </a> */}
                            <a href="https://www.instagram.com/arca.armenia" target="_blank" rel="noreferrer">
                                Instagram
                            </a>
                            <a href="https://www.youtube.com/@Arca-ArmenianCardCJSC" target="_blank" rel="noreferrer">
                                YouTube
                            </a>
                        </div>
                    </div>
                </div>
                <div className="footer_credentials-container">
                    <div className="footer-credentials">
                        <span style={dynamicStyles}>{footerText[language][4].test}</span>
                        <div className="footer-privacy">
                            <Link to="/privacy-policy" style={dynamicStyles}>
                                {footerText[language][5].privacy}
                            </Link>
                            {/* <Link to="/terms-conditions" style={dynamicStyles}>
                                {footerText[language][5].terms}
                            </Link> */}
                        </div>
                    </div>
                    <span className="bygaroon">
                        Design & Development By{" "}
                        <a href="https://gsca.digital/" target="_blank">
                            GSCA
                        </a>
                    </span>
                </div>
            </div>
            </div>
        </>
    );
}

export default Footer;
